export default class BTabs
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.tabs--active`;

	static initialize()
	{
		document.querySelectorAll(`.tabs`).forEach(el => {
			const tabs = new this(el);
			tabs.prepare();
		});

		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener('click', event => {
			if (event.target.matches(`${BTabs.selector()} .tabs__nav-item, ${BTabs.selector()} .tabs__nav-item *`)) {
				event.preventDefault();

				const buttonEl = event.target.closest(`.tabs__nav-item`);
				const tabs = new BTabs(buttonEl.closest(`.tabs`));

				tabs.setTab(buttonEl.dataset.tabId);
			}
		});
	}

	prepare()
	{
		this.setTab(this.getTabIds()[0]);
	}

	setTab(tabId)
	{
		this.el.querySelectorAll(`${BTabs.selector()} .tabs__nav-item`).forEach(el => {
			el.classList.remove('tabs__nav-item--active');
		});

		this.el.querySelectorAll(`${BTabs.selector()} .tabs__nav-item[data-tab-id="${tabId}"]`).forEach(el => {
			el.classList.add('tabs__nav-item--active');
		});

		this.el.querySelectorAll(`${BTabs.selector()} .tabs__tab`).forEach(el => {
			el.setAttribute('hidden', '');
		});

		this.el.querySelectorAll(`${BTabs.selector()} .tabs__tab[data-tab-id="${tabId}"]`).forEach(el => {
			el.removeAttribute('hidden');
		});
	};

	getTabIds()
	{
		let tabIds = [];
		this.el.querySelectorAll(`.tabs__tab`).forEach(el => {
			tabIds.push(el.dataset.tabId);
		});

		return tabIds;
	}
}
